import _ from 'lodash'

import { LoadingContainer, Model, Panels, Bar, Json } from 'peach/components'
import { humanizeKey } from 'peach/helpers'
import { useParams } from 'peach/router'

import { useListPersonDocuments } from 'core/types'
import { Page } from 'core/components'

const LoanDocuments = () => {
  const { personId } = useParams<{
    personId?: string
    loanId?: string
  }>()

  const {
    data: documents,
    isLoading,
    error,
  } = useListPersonDocuments({
    personId,
  })

  const documentsByStatus = _.groupBy(documents, 'status')

  const displayGroups = _.map(documentsByStatus, (docs, status) => (
    <Model.List json={docs} noLink title={`${humanizeKey(status)} Documents`} />
  ))

  return (
    <Panels header={<Bar title='Documents' />}>
      <LoadingContainer error={error} loading={isLoading}>
        <Page variant='full'>
          {_.isEmpty(documents) ? <Json.Table json={[]} /> : displayGroups}
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanDocuments
